var map = {
	"./deck-cards/1/1.svg": 723,
	"./deck-cards/1/10.svg": 724,
	"./deck-cards/1/11.svg": 725,
	"./deck-cards/1/12.svg": 726,
	"./deck-cards/1/13.svg": 727,
	"./deck-cards/1/14.svg": 728,
	"./deck-cards/1/15.svg": 729,
	"./deck-cards/1/16.svg": 730,
	"./deck-cards/1/17.svg": 731,
	"./deck-cards/1/18.svg": 732,
	"./deck-cards/1/19.svg": 733,
	"./deck-cards/1/2.svg": 734,
	"./deck-cards/1/20.svg": 735,
	"./deck-cards/1/21.svg": 736,
	"./deck-cards/1/22.svg": 737,
	"./deck-cards/1/23.svg": 738,
	"./deck-cards/1/24.svg": 739,
	"./deck-cards/1/25.svg": 740,
	"./deck-cards/1/26.svg": 741,
	"./deck-cards/1/27.svg": 742,
	"./deck-cards/1/28.svg": 743,
	"./deck-cards/1/29.svg": 744,
	"./deck-cards/1/3.svg": 745,
	"./deck-cards/1/30.svg": 746,
	"./deck-cards/1/31.svg": 747,
	"./deck-cards/1/32.svg": 748,
	"./deck-cards/1/33.svg": 749,
	"./deck-cards/1/34.svg": 750,
	"./deck-cards/1/35.svg": 751,
	"./deck-cards/1/36.svg": 752,
	"./deck-cards/1/37.svg": 753,
	"./deck-cards/1/38.svg": 754,
	"./deck-cards/1/39.svg": 755,
	"./deck-cards/1/4.svg": 756,
	"./deck-cards/1/40.svg": 757,
	"./deck-cards/1/41.svg": 758,
	"./deck-cards/1/42.svg": 759,
	"./deck-cards/1/43.svg": 760,
	"./deck-cards/1/44.svg": 761,
	"./deck-cards/1/45.svg": 762,
	"./deck-cards/1/46.svg": 763,
	"./deck-cards/1/47.svg": 764,
	"./deck-cards/1/48.svg": 765,
	"./deck-cards/1/49.svg": 766,
	"./deck-cards/1/5.svg": 767,
	"./deck-cards/1/50.svg": 768,
	"./deck-cards/1/51.svg": 769,
	"./deck-cards/1/52.svg": 770,
	"./deck-cards/1/6.svg": 771,
	"./deck-cards/1/7.svg": 772,
	"./deck-cards/1/8.svg": 773,
	"./deck-cards/1/9.svg": 774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 301;